<section
  *ngIf="blockData"
  #successStoriesSection
  class="section section--soc-include success-stories-block-section"
>
  <div
    id="success-stories-cubes-angular-portal"
    class="container container--padding"
  >
    <div class="masters-block">
      <!-- Header Section -->
      <div class="success-stories-header">
        <div class="success-stories-header_text">
          <h2 class="title title--mid title--dark">{{ blockData.title }}</h2>
          <div class="masters-block__text">{{ blockData.subTitle }}</div>
        </div>

        <!-- Search Box -->
        <div
          *ngIf="blockData.showSearch"
          class="small-search small-search--mini"
        >
          <div class="small-search__icon">
            <!-- SVG code -->
          </div>
          <button
            class="small-search__clear"
            type="button"
            (click)="searchClear()"
          >
            <img src="/Content/Images/icons/clear.svg" width="12" height="12" />
          </button>
          <div class="small-search__input">
            <input
              id="search-filter"
              [(ngModel)]="searchText"
              (ngModelChange)="updateSearchCubesList()"
              [placeholder]="blockData.searchPlaceholder"
            />
          </div>
        </div>
      </div>

      <!-- Swiper Slider View -->
      <div
        *ngIf="blockData.useSliderView"
        id="include-vue-swiper"
        class="soc-include__slider js-dmi"
      >
        <swiper-container
          #swiper
          pagination="true"
          navigation="true"
          pagination-clickable="true"
          [breakpoints]="breakpoints"
        >
          <swiper-slide
            lazy="true"
            *ngFor="let cube of searchCubesList"
            [id]="'swiper-slide-' + cube.id"
          >
            <div class="include-item">
              <div class="include-item__img">
                <img
                  [src]="getProcessedCubeImageUrl(cube.imageUrl)"
                  loading="lazy"
                />
              </div>
              <div
                class="include-item__body js-swiper-drop"
                (click)="includeItemClick(cube)"
              >
                <div class="include-item__body-top">
                  <div class="include-item__icon">
                    <img
                      *ngIf="checkIfShowIncludeItem(cube)"
                      alt="plus"
                      src="/Content/Images/icons/plus.png?width=34&height=34&mode=crop&format=webp"
                    />
                  </div>
                  <div class="include-item__name">{{ cube.title }}</div>
                </div>
                <div
                  *ngIf="checkIfShowIncludeItem(cube)"
                  class="include-item__drop"
                >
                  <div *ngIf="cube.description" class="include-item__text">
                    {{ cube.description }}
                  </div>
                  <a
                    *ngIf="cube.linkUrl"
                    [href]="cube.linkUrl"
                    class="link link--title"
                    [target]="cube.linkTarget"
                  >
                    <div class="link__text">{{ cube.linkText }}</div>
                  </a>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper-container>
      </div>

      <!-- Non-Slider View -->
      <div *ngIf="!blockData.useSliderView" class="soc-include__slider">
        <div class="swiper-wrapper-success-stories">
          <div class="slider-row-chunk">
            <div
              *ngFor="let cube of searchCubesList; let key = index"
              [id]="'swiper-slide-' + cube.id"
              class="swiper-slide"
            >
              <div class="include-item">
                <div class="include-item__img">
                  <img [src]="getProcessedCubeImageUrl(cube.imageUrl)" />
                </div>
                <div
                  class="include-item__body js-swiper-drop"
                  (click)="includeItemClick(cube)"
                >
                  <div class="include-item__body-top">
                    <div class="include-item__icon">
                      <img
                        *ngIf="checkIfShowIncludeItem(cube)"
                        alt="plus"
                        src="/Content/Images/icons/plus.png?width=34&height=34&mode=crop&format=webp"
                      />
                    </div>
                    <div class="include-item__name">{{ cube.title }}</div>
                  </div>
                  <div
                    *ngIf="checkIfShowIncludeItem(cube)"
                    class="include-item__drop"
                  >
                    <div *ngIf="cube.description" class="include-item__text">
                      {{ cube.description }}
                    </div>
                    <a
                      *ngIf="cube.linkUrl"
                      [href]="cube.linkUrl"
                      class="link link--title"
                      [target]="cube.linkTarget"
                    >
                      <div class="link__text">{{ cube.linkText }}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- "Show All" Button -->
        <button
          *ngIf="
            !showAll &&
            blockData.cubesList.length > blockViewDisplayCount &&
            allResults > blockViewDisplayCount
          "
          class="show-all-btn button button--main"
          (click)="showAllBtnClick()"
        >
          {{ blockData.loadMoreBtnText }}
        </button>
      </div>

      <!-- No Results Text -->
      <div *ngIf="searchCubesList.length == 0" class="no-results-text">
        {{ blockData.noResultsText }}
      </div>
    </div>
  </div>
</section>
